import Vue, { CreateElement, RenderContext, VNode } from "vue";
import BaseIcon from "@/components/BaseIcon";
import { LoadingThumbnail } from "@/components/ContentLoadingPlaceholders";
import ImagePreview from "@/components/ImagePreview";
import "./style.scss";

interface Props {
  src: string;
  loading: boolean;
  publicAccess: boolean;
  progress: number;
}
export default Vue.extend<Props>({
  functional: true,
  name: "MediaPreview",
  props: {
    src: { type: String, default: "" },
    publicAccess: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    progress: { type: Number, default: 100 },
  },
  render(h: CreateElement, ctx: RenderContext<Props>): VNode | VNode[] {
    const LockIcon = () => {
      if (!ctx.props.publicAccess) return null;
      return h(BaseIcon, { staticClass: "media-preview__icon __lock ma-1 pa-1", props: { fontSize: 13 } }, [
        "sci-lock-open-variant-outline",
      ]);
    };

    const Image = ({ loaded, loading }: { loaded: boolean; loading: boolean }) => {
      if (ctx.props.progress === 0 || loaded) {
        return h(ImagePreview, {
          ...ctx.data,
          props: { ...ctx.props, size: "72px", loading: ctx.props.loading || loading },
          scopedSlots: { bottomLeftIcon: LockIcon },
        });
      }
      return null;
    };

    return h("div", { class: "media-preview", on: ctx.listeners }, [
      h(LoadingThumbnail, { class: "media-preview__progress-bar", props: { progress: ctx.props.progress } }, [Image]),
      h(BaseIcon, { staticClass: "media-preview__icon __close ma-1", props: { fontSize: 18 } }, ["sci-cross"]),
    ]);
  },
});
